module.exports = __webpack_public_path__ + "img/bg_home.2e18cd64.png";